import React from 'react';

const SignalIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="44"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#1a5d3a"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
  </svg>
);

const SignalsFeed = () => (
  <div
    className="bg-white rounded-xl p-8 shadow-sm border border-gray-100 flex flex-col items-center justify-center text-center"
    style={{ minHeight: '220px' }}
    data-testid="signals-feed-panel"
  >
    <div
      className="w-16 h-16 rounded-2xl flex items-center justify-center mb-5"
      style={{ backgroundColor: '#f5f0e8' }}
    >
      <SignalIcon />
    </div>
    <h2 className="text-base font-semibold text-gray-900 mb-2">Your Signal Feed</h2>
    <p className="text-sm text-gray-500 max-w-xs leading-relaxed">
      Activity, milestones, and alerts will appear here as you build your profile.
    </p>
  </div>
);

export default SignalsFeed;
